// src/site/hooks/useAlgoliaSiteIndex.js
// Hook responsável por expor { index, ready } da instância Algolia
// para o SiteFilterBar (sugestões via searchForFacetValues).

import { useEffect, useState } from 'react';
import { getSearchClient } from '../../services/searchClient';

function resolveIndexName(sort = 'created', base = 'imoveis') {
  switch ((sort || '').toLowerCase()) {
    case 'price_asc':
    case 'preco_asc':
      return `${base}_by_price_asc`;
    case 'price_desc':
    case 'preco_desc':
      return `${base}_by_price_desc`;
    case 'created':
    case 'created_desc':
    case 'data_desc':
    default:
      return `${base}_by_created_desc`;
  }
}

export default function useAlgoliaSiteIndex(handle, sort = 'created') {
  const [index, setIndex] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    setIndex(null);
    setReady(false);

    (async () => {
      try {
        const indexName = resolveIndexName(sort, 'imoveis');
        const engine = await getSearchClient({ handle, indexName });
        if (!alive) return;

        if (engine && engine.type === 'algolia' && engine.index) {
          setIndex(engine.index);
          setReady(true);
        } else {
          setIndex(null);
          setReady(false);
        }
      } catch (e) {
        if (alive) {
          console.warn('[useAlgoliaSiteIndex] erro:', e?.message || e);
          setIndex(null);
          setReady(false);
        }
      }
    })();

    return () => {
      alive = false;
    };
  }, [handle, sort]);

  return { index, ready };
}
